import { render } from "./Login.vue?vue&type=template&id=45d3e669"
import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/Login.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45d3e669"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45d3e669', __exports__)) {
    api.reload('45d3e669', __exports__)
  }
  
  module.hot.accept("./Login.vue?vue&type=template&id=45d3e669", () => {
    api.rerender('45d3e669', render)
  })

}


export default __exports__